export default __webpack_public_path__ + "static/media/federal-land-min.14897183.png";